import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { Card, Icon } from '../../ui';
import { EditorContext } from '../EditorContext';
import { Subject, Tracker } from '../types';
import Measurement from './Measurement';

interface SubjectWithTrackersProps {
  subject: Subject;
  'data-testid': string;
}

type GroupInfo =
  | {
      name: string;
      id: string;
    }
  | undefined
  | null;

const SubjectWithTrackers: React.FC<SubjectWithTrackersProps> = ({ subject }) => {
  const { state, dispatch } = useContext(EditorContext);

  return (
    <div className="mb4">
      <div className="flex items-center justify-between mb3">
        {state.subjectDisplay.length > 1 && (
          <button
            type="button"
            onClick={() => dispatch({ type: 'removeSubject', subjectId: subject.id })}
          >
            <Icon name="close" />
          </button>
        )}
      </div>

      {subject.groups.map(group => (
        <Card
          key={`${subject.id}-${group.id}`}
          data-testid={`subject-${subject.slug}-trackers`}
          className="mb3"
        >
          {group && <h3 className="f7 normal mt0 mb1 bb b--light-gray ph3 pv2">{group.name}</h3>}

          {group.trackers &&
            group.trackers.map((tracker, index) => (
              <Measurement
                key={`${tracker.id}-${subject.id}-${group.id}`}
                subjectId={subject.id}
                tracker={tracker as Tracker}
                data-testid={`edit-tracker-${tracker.slug}`}
                last={group.trackers!.length - 1 === index}
              />
            ))}
          {!subject.trackers.filter(tracker => tracker.active).length && (
            <p className="ph3 f6 tan" data-testid="trackers-empty-message">
              Add trackers for {subject.name} in{' '}
              <Link
                to={`/notebook/subject/${subject.slug}`}
                state={{ isEmpty: true }}
                className="blue hover-navy"
              >
                Subject Settings
              </Link>
            </p>
          )}
        </Card>
      ))}
    </div>
  );
};

export default SubjectWithTrackers;
